export default "__VITE_ASSET__BqI_VH7v__"